import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RequestState, RequestStateEnum } from "@app-common/http/RequestState";
import { AU_BANK } from "@app-common/http/interceptors/tenantType";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { UserService } from "@app-service/user.service";
import { PopupLayoutComponent } from "app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { MandateConstants } from "app/admin/create-mandate/mandate-constant";
import { NgxOtpInputComponent, NgxOtpInputComponentOptions } from "ngx-otp-input";
import { Subscription } from "rxjs";

@Component({
    selector: "app-tenant-switch-otp-popup",
    templateUrl: "./tenant-switch-otp-popup.component.html",
    styleUrls: ["./tenant-switch-otp-popup.component.scss"],
    standalone: false
})
export class TenantSwitchOtpPopupComponent implements OnInit {
  @HostListener("document:keypress", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.onVerify.emit({
        submitRequestState: this.submitRequestState,
        otpValue: this.form.get("otp").value,
      });
    }
  }

  @ViewChild("ngxotp") ngxotp: NgxOtpInputComponent;
  @ViewChild("modal") modal: PopupLayoutComponent;
  private valueChangesSub: Subscription[] = [];
  cardOtpResponse: any;
  submitRequestState: RequestState;

  fetchUsageSettings: RequestState;

  @Input()
  provider: "FINCARE" | "AU_BANK" | "TRANSCORP" | "INDUSIND";

  @Input()
  onVerify: EventEmitter<any> = new EventEmitter();

  @Input()
  dismissModal: EventEmitter<any> = new EventEmitter();

  @Input()
  mobile: number;

  interval = null;

  timeLeft: number = 60;

  form: FormGroup = new FormGroup({
    otp: new FormControl("", [
      Validators.required,
      Validators.pattern(/^\d{6}$/),
    ]),
  });

  //TODO: ADD THE CLASSED TO COMPONENT ITSELF
    // classList: {
    //   container: "custom-container-otp",
    //   inputBox: "custom-input-box-otp",
    //   input: "custom-input-otp",
    // },

  otpInputConfig: NgxOtpInputComponentOptions = {
    otpLength: 6,
    autoFocus: true, 
    autoBlur: true, 
    hideInputValues: false,
    showBlinkingCursor: true,
    ariaLabels: ['OTP Input'],
    inputMode: 'numeric'
  };

  constructor(
    private toasterService: ToasterService,
    private userService: UserService
  ) {
    this.fetchUsageSettings = RequestState.init();
    this.submitRequestState = RequestState.init();
  }

  ngOnInit(): void {
    this.fetchUsageSettings.pending();
    this.valueChangesSub.push(
      (this.provider === AU_BANK
        ? this.userService.loginAu(this.mobile)
        : this.userService.loginInd(this.mobile)
      ).subscribe(
        (res) => {
          this.cardOtpResponse = res.payload;
          this.startTimer();
          this.fetchUsageSettings.completed();
        },
        (error) => {
          const errorJson = error["error"];
          if (errorJson != null && errorJson["response_message"] != null) {
            this.openSnackBar(
              error[MandateConstants.error][MandateConstants.responseMessage],
              ToasterType.ERROR
            );
          } else {
            this.openSnackBar("Something went Wrong", ToasterType.ERROR);
          }
          this.fetchUsageSettings.completed();
        }
      )
    );
    this.dismissModal.subscribe((item) => {
      this.modal.dismiss();
    });
  }

  patchOtpValue(value) {
    this.form.patchValue({
      otp: parseInt(value),
    });
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.clearTimer();
      }
    }, 1000);
  }

  clearTimer() {
    clearInterval(this.interval);
    this.interval = null;
  }

  maskPhoneNumber(number: number): string {
    if (!number) return;
    return number
      .toString()
      .replace(/([0-9]{2})([0-9]{5,6})([0-9]{2})/, function ($0, $1, $2, $3) {
        return $1 + $2.replace(/\d/g, "X") + $3;
      });
  }

  onResendOtp(): void {
    this.valueChangesSub.push(
      (this.provider === AU_BANK
        ? this.userService.loginAu(this.mobile)
        : this.userService.loginInd(this.mobile)
      ).subscribe(
        () => {
          this.form.reset();
          this.ngxotp.reset();;
          this.openResendOTPSnackBar();
          this.timeLeft = 60;
          this.startTimer();
        },
        (error) => {
          const errorJson = error["error"];
          if (errorJson != null && errorJson["response_message"] != null) {
            this.openSnackBar(
              error[MandateConstants.error][MandateConstants.responseMessage],
              ToasterType.ERROR
            );
          } else {
            this.openSnackBar("Something went Wrong", ToasterType.ERROR);
          }
        }
      )
    );
  }

  openResendOTPSnackBar() {
    this.toasterService.showToaster(
      `OTP has been sent to Your registered Mobile Number`,
      ToasterType.INFO
    );
  }
  openSnackBar(message: string, type) {
    this.toasterService.showToaster(message, type);
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }
}
